import { PlanType } from '@otter-ai/recall-client';

export function formatName(
  plan: PlanType,
  firstName: string,
  teamName?: string,
) {
  const isProPlan = plan === 'premium';
  return isProPlan ? `${firstName}'s Workspace` : teamName;
}

export function formatCredit(credit: number, minorUnitsAmountDivisor: number) {
  return (credit / minorUnitsAmountDivisor).toFixed(2);
}
